import type { HelpFile } from '../../types/help'
import { SapAbapOutboundConfigCardTestIds } from '../../../testids/SapAbapOutboundConfigCardTestIds'

export const sapAbapOutboundConfigCardHelp: HelpFile = {
  docPage: '/docs/connectors/sap-abap-connector',
  texts: {
    [SapAbapOutboundConfigCardTestIds.sapAbapConfigSection]:
      'Outbound provisioning into SAP ABAP. OData V2 covers configuration and role assignment in OData mode; the optional RFC/BAPI path covers user creation and role assignment via BAPI_USER_CREATE1 / BAPI_USER_ACTGRPS_ASSIGN.',
    [SapAbapOutboundConfigCardTestIds.cardTitleSapAbapConfig]: null,
    [SapAbapOutboundConfigCardTestIds.btnEditSapAbapConfig]: null,
  },
}
